import { useIsSubscriptionTrialing } from "@/hooks/useSubscriptions";
import { Route } from "@/paths";
import { ActionIcon, Button, Group } from "@mantine/core";
import { FaCircleUser } from "react-icons/fa6";
import { Link } from "react-router-dom";

export const ProfileButton = () => {
  const [isTrialing] = useIsSubscriptionTrialing();

  return (
    <Group gap={8}>
      {isTrialing && (
        <Button
          component={Link}
          to={Route.Pricing}
          size="compact-md"
          fz={14}
          color="green.8"
          visibleFrom="md"
        >
          See Plans
        </Button>
      )}
      <ActionIcon
        h={30}
        variant="transparent"
        radius={999}
        size={"md"}
        component={Link}
        to={Route.Profile}
        target="_blank"
        color="accent"
      >
        <FaCircleUser size={24} />
      </ActionIcon>
    </Group>
  );
};
